import {
  LoyaltyType,
  SOLUTION_DISCOUNT_NAME,
} from '../../../../../../../../graphql/promotions/models/get-promotions.models';

const VOUCHER_DESCRIPTION_KEYS: Record<string, string> = {
  [LoyaltyType.discountFirstPurchase]: 'promotions.firstVoucher.shortDescription',
  [LoyaltyType.discountSecondPurchase]: 'promotions.secondVoucher.shortDescription',
  [SOLUTION_DISCOUNT_NAME]: 'promotions.solutionVoucher.shortDescription',
};

export const getVoucherDescriptionKey = (name: string): string | undefined =>
  VOUCHER_DESCRIPTION_KEYS[name];
